/* Site Ready */
/* ---------------------------------------------------------------------------------------------------- */
jQuery(document).ready(function(){
    
    /* Detect Platform */
    /* ------------------------------------------------------------------------------------------------ */
    detectPlatform();
    
    /* Forms */
    /* ------------------------------------------------------------------------------------------------ */
    ipcrimeFormsInit();
    
    /* Generic */
    /* ------------------------------------------------------------------------------------------------ */
    ipcrimeGenericInit();
    
    /* Trademark Holders Pricing */
    /* ------------------------------------------------------------------------------------------------ */
    ipcrimeTrademarkHoldersPricingInit();

});